export default __webpack_public_path__ + "static/media/solucao-05.6c014bc0.webp";